module.exports = __webpack_public_path__ + "static/img/YD30.79be435.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YD30.png
// module id = aeDp
// module chunks = 2